import React from "react";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import Header from "./Header";

const Layout = (props) => {
  const school_user = JSON.parse(localStorage.getItem("school_user"));
  const isRedirectedUser = localStorage.getItem("userRedirectionfromMobile");

  return (
    <div id="main_content">
      {isRedirectedUser == "true" ? "" : <Sidebar />}
      <div className={isRedirectedUser == "true" ? "" : "page"}>
        {isRedirectedUser == "true" ? "" : <Header school_user={school_user} />}
        {props.children}
        <Footer />
      </div>
    </div>
  );
};

export default Layout;
